import { ReportsListTemplate } from "app/features/reporting/templates/ReportsListTemplate";

export function ResidentReportsScreen() {
  return <ReportsListTemplate />;
}
